import React, {useMemo} from 'react'
import Title from '../text/Title'
import WizSelectButton from '../button/WizSelectButton'
import {useNavigate} from 'react-router-dom'

interface IProps {
    className?: string
    children?: any
    title?: string
    isFull?: string
    renderTitle?: React.ReactNode
}

const PageLayout: React.FC<IProps> = ({className, children, title, isFull = true, renderTitle}) => {
    const navigate = useNavigate()
    const onChangeLang = e => {
        if (e.id === 'en') {
            localStorage?.setItem('lang', 'en')
        } else {
            localStorage?.setItem('lang', 'ko')
        }

        navigate(0)
    }

    const languageList = useMemo(() => {
        return [
            {id: 'en', value: 'EN'},
            {id: 'ko', value: 'KO'},
        ]
    }, [])

    return (
        <div className={`py-[60px] px-[40px] flex-1 w-screen bg-line04 lg:mt-[35px] sm:px-[20px] sm:mt-[40px]`}>
            <div className={'flex justify-between items-center'}>
                <div className="flex flex-1 items-center gap-x-[10px]">
                    <Title className={'text-landing_heading3 font-landing sm:text-center sm:w-full sm:text-h1'}>
                        {`${title} - ${localStorage?.getItem('lang')?.toUpperCase() || 'EN'}`}
                    </Title>
                    {renderTitle}
                </div>
                <div className={'lg:fixed lg:top-[10px] lg:right-[40px] lg:z-[1]'}>
                    <WizSelectButton
                        onChange={e => onChangeLang(e)}
                        data={languageList}
                        activeValue={languageList?.find(item => localStorage.getItem('lang') === item.id)}
                    />
                </div>
            </div>
            <div className={`mt-[50px] sm:mt-[70px] ${className}`}>{children}</div>
        </div>
    )
}

export default PageLayout
